import { render, staticRenderFns } from "./OuvrageSvg.vue?vue&type=template&id=053052bd&"
import script from "./OuvrageSvg.vue?vue&type=script&lang=js&"
export * from "./OuvrageSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports